import { HttpError } from 'react-admin';

import { ErrorCodes, errorCodes } from '../../constants/errorMessages';

// 429 covers every rate limiter we run, including the step-up limiter a run of wrong mfa codes
// ends in. The api cannot answer those with an error code of its own: express-rate-limit replies
// with a plain string body, so fetchJson has no message to parse out and falls back to statusText.
const expectedErrorStatuses = [401, 404, 429];

const isExpectedAPIError = (e: HttpError) => {
  if (expectedErrorStatuses.includes(e.status)) return true;

  if (Object.values(errorCodes).includes(e.message as ErrorCodes)) return true;

  return false;
};

export default isExpectedAPIError;
